import React from 'react';
import Skeleton from './Skeleton';
import './SeriesCardSkeleton.scss';

interface SeriesCardSkeletonProps {
  count?: number;
  className?: string;
}

const SeriesCardSkeleton: React.FC<SeriesCardSkeletonProps> = ({
  count = 1,
  className = ''
}) => {
  const renderSkeletonCard = () => (
    <div className={`series-card-skeleton ${className}`}>
      {/* 右上角语言标签骨架 */}
      <div className="episode-tag-skeleton">
        <Skeleton 
          width="40px" 
          height="20px" 
          variant="rectangular"
          animation="pulse"
        />
      </div>

      {/* 文件夹图标骨架 */}
      <div className="clickable-area-skeleton">
        <div className="folder-icon-skeleton">
          <Skeleton 
            width="60px" 
            height="60px" 
            variant="circular"
            animation="wave"
          />
        </div>
      </div>

      {/* 剧集名称骨架 */}
      <div className="episode-name-section-skeleton">
        <Skeleton 
          width="85%" 
          height="16px" 
          variant="text"
          animation="wave"
        />
      </div>

      {/* 底部操作按钮骨架 */}
      <div className="episode-actions-skeleton">
        <Skeleton 
          width="32px" 
          height="32px" 
          variant="circular"
          animation="pulse"
        />
        <Skeleton 
          width="32px" 
          height="32px" 
          variant="circular"
          animation="pulse"
        />
      </div>
    </div>
  );

  if (count === 1) {
    return renderSkeletonCard();
  }

  return (
    <>
      {Array.from({ length: count }, (_, index) => (
        <React.Fragment key={index}>
          {renderSkeletonCard()}
        </React.Fragment>
      ))}
    </>
  );
};

export default SeriesCardSkeleton;
